/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Buyer_SavingInputs */

const vi_einvoice_buyer_saving = /** @type {(inputs: Einvoice_Buyer_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang lưu và tạo bản nháp…`)
};

/**

* @param {Einvoice_Buyer_SavingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_buyer_saving = /** @type {((inputs?: Einvoice_Buyer_SavingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Buyer_SavingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_buyer_saving(inputs)
});